class SortPopover extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.sort-popover__trigger');
    this.label = this.querySelector('.sort-popover__label');
    this.panel = this.querySelector('.sort-popover__panel');
    this.select = this.querySelector('select');

    this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
    this.panel.querySelectorAll('.sort-popover__option').forEach((option) => {
      option.addEventListener('click', this.onOptionClick.bind(this));
    });
    document.addEventListener('click', this.onDocumentClick.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onTriggerClick() {
    this.classList.contains('is-open') ? this.close() : this.open();
  }

  open() {
    this.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.panel.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
  }

  onOptionClick(event) {
    const option = event.currentTarget;
    const value = option.dataset.value;

    if (this.select.value !== value) {
      this.select.value = value;
      this.select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    this.label.textContent = option.querySelector('.sort-popover__option-label').textContent.trim();

    this.panel.querySelectorAll('.sort-popover__option').forEach((otherOption) => {
      const isActive = otherOption === option;
      otherOption.classList.toggle('sort-popover__option--active', isActive);
      otherOption.setAttribute('aria-selected', isActive);
    });

    this.close();
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  onKeyUp(event) {
    if (event.code === 'Escape') {
      this.close();
      this.trigger.focus();
    }
  }
}

customElements.define('sort-popover', SortPopover);
